import { render, staticRenderFns } from "./redbag.vue?vue&type=template&id=5e1d0ada&"
import script from "./redbag.vue?vue&type=script&lang=js&"
export * from "./redbag.vue?vue&type=script&lang=js&"
import style0 from "./redbag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports